export const inspectTable = [
  {
    title: "밀폐공간 허가",
    content: "밀폐공간작업 장소 보유 현황 및 위치 등에 대한 자료가 작성되어 있는가?",
    isChecked: "",
  },
  {
    title: "밀폐공간 허가",
    content: "밀폐공간 출입 시 작업허가서를 작성하여 발급 받았는가?",
    isChecked: "",
  },
  {
    title: "밀폐공간 허가",
    content: "작업허가서는 규정 양식을 사용하여 올바르게 작성되었는가?",
    isChecked: "",
  },
  {
    title: "밀폐공간 허가",
    content: "프로그램 추진팀(장)은 작업허가서를 적법한 절차에 의해 발급하였는가?",
    isChecked: "",
  },
  {
    title: "산소 및 유해가스 농도측정",
    content: "산소 및 유해가스 농도 측정대상 물질은 적정하게 선택되었으며 측정시 누락된 물질은 없는가?",
    isChecked: "",
  },
  {
    title: "산소 및 유해가스 농도측정",
    content: "측정 장비의 신뢰성(교정 등)은 확보되었는가?",
    isChecked: "",
  },
  {
    title: "산소 및 유해가스 농도측정",
    content: "측정지점수, 측정방법 등은 정해진 규정을 준수하였는가?",
    isChecked: "",
  },
  {
    title: "산소 및 유해가스 농도측정",
    content: "측정결과에 대한 판정은 적합하게 이루어졌는가?",
    isChecked: "",
  },
  {
    title: "환기대책",
    content: "밀폐공간작업 장소에 따라 적합한 환기방법, 환기량 선정 등 환기대책은 적절하게 수립되었는가?",
    isChecked: "",
  },
  {
    title: "환기대책",
    content: "환기팬의 점검은 주기적으로 실시하였는가?",
    isChecked: "",
  },
  {
    title: "보호구 선정 및 사용",
    content: "보호구의 종류 및 수량은 충분한가?",
    isChecked: "",
  },
  {
    title: "보호구 선정 및 사용",
    content: "보호구의 보유수량 및 대여필요장비 목록은 작성되어 있는가?",
    isChecked: "",
  },
  {
    title: "보호구 선정 및 사용",
    content: "작업에 따라 적합한 보호구가 선정되어 사용되었는가?",
    isChecked: "",
  },
  {
    title: "보호구 선정 및 사용",
    content: "누출검사를 매 사용 시마다 시행하도록 하고 있는가?",
    isChecked: "",
  },
  {
    title: "보호구 선정 및 사용",
    content: "보호구를 주기적으로 청소, 점검 등을 실시하는가?",
    isChecked: "",
  },
  {
    title: "응급처치 체계",
    content: "응급상황 발생 시 비상연락을 위한 체계는 구축되어 있는가?",
    isChecked: "",
  },
  {
    title: "응급처치 체계",
    content: "응급전화, 무전기 등의 통신장비는 구비되어 있는가?",
    isChecked: "",
  },
  {
    title: "교육 및 훈련의 적정성",
    content: "프로그램 관리자, 관리감독자, 작업자 등에 대한 교육계획을 수립하여 시행하고 있는가?",
    isChecked: "",
  },
  {
    title: "교육 및 훈련의 적정성",
    content: "밀폐공간 작업시마다 작업자에게 교육을 실시하고 있는가?",
    isChecked: "",
  },
  {
    title: "교육 및 훈련의 적정성",
    content: "관련교육을 실시하는 경우 교육내용 등을 기록하고 보존하는가?",
    isChecked: "",
  },
  {
    title: "교육 및 훈련의 적정성",
    content: "교육내용, 자료 등은 적절하며 최신성을 유지하고 있는가?",
    isChecked: "",
  },
  {
    title: "교육 및 훈련의 적정성",
    content: "교육받는 자는 교육내용을 충분히 숙지하여 작업에 올바르게 적용하고 있는가?",
    isChecked: "",
  },

];
